import { SerializedStyles } from "@emotion/react";
import { Checkbox } from "src/components";
import { selectApplicationCountry } from "src/selectors";
import { createStyles } from "src/styles";

import { types } from "@fraction/shared";

interface CreditCheckConsentProps {
  value: boolean;
  setValue: (value: boolean) => void;
  location?: types.ExtractedPropertyAddress;
  label?: string;
  style?: SerializedStyles;
}

const LABEL_GENERIC = "I consent to having my credit report pulled by Fraction.";
const LABEL_EXPERIAN = `By checking this box, I understand that I am providing 'written instructions' to
Fraction under the Fair Credit Reporting Act authorizing Fraction to obtain information from my personal
credit profile or other information from Experian. I authorize Fraction to obtain such information solely to
conduct a pre-qualification for credit.`;

const styles = createStyles({
  label: {
    maxWidth: "unset",
  },
});

const CreditCheckConsent = ({ value, setValue, location, label, style }: CreditCheckConsentProps) => {
  const { isUSA } = selectApplicationCountry(location?.country);
  const labelFinal = label || (isUSA ? LABEL_EXPERIAN : LABEL_GENERIC);
  return (
    <Checkbox
      label={labelFinal}
      checked={value}
      onChange={setValue}
      style={style}
      labelStyle={styles.label}
    />
  );
};

export default CreditCheckConsent;
